import React from "react";
import { NavLink } from "react-router-dom";

import { FaCheck, FaLock, FaEye, FaUnlock } from "react-icons/fa";

import thumb_proof from "../../../assets/img/avaliacao-aprendizagem-400x225.jpg";

export default function ModuleEvaluationtComponent({
  userHasVideo,
  videoWasWatched,
  courseFinishState,
  courseFinishedDB,
  course,
  course_proof_type,
}) {
  const isScorm = (course.video && typeof course.video === 'object') ? course.video.id : course.video;
  return (
    <div>
      <div key={course.proof.id} className="course-item-sider-bar">
        <NavLink
          data-gtm-type="click"
          data-gtm-clicktype="link"
          data-gtm-name="avaliação de aprendizado"
          className={`proof_slide ${!!isScorm && !userHasVideo && !videoWasWatched && "disabled"}`}
          exact={true}
          activeClassName={"selected"}
          to={`/curso/${course.id}/proof/${course.proof.id}`}
        >
          <div className="course-item-icon">
            {
              !isScorm || userHasVideo || videoWasWatched
                ? courseFinishedDB || courseFinishState
                  ? (
                    <FaCheck color={"#07a803"} />
                  )
                  : course_proof_type === "proof"
                    ? (
                      <FaEye color={"#009ee2"} />
                    ) : (
                      <FaUnlock color={"#009ee2"} />
                    )
                : (
                  <FaLock color={"#ff5a40"} />
                )
            }
          </div>
          <img src={thumb_proof} />
        </NavLink>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/CoursePage/Components/ModuleEvaluationtComponent.jsx